export default __webpack_public_path__ + "atomic/_patterns/01-atoms/field-fact-and-figure/_field-fact-and-figure.twig";